import { dentalRobotTheme } from "./dentalRobot.theme";
import { divaTheme } from "./diva.theme";

export const getTheme = (themeName) => {
  switch (themeName) {
    case "dentalRobot":
      return dentalRobotTheme;
    case "diva":
      return divaTheme;
    default:
      return dentalRobotTheme;
  }
};
